/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/header.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IHeaderMethods extends IPluginMethodMap {
  getHeaderProps(args: any): Promise<any>;
}
const storageSrv = StorageModule?.getInstance();

export class HeaderService implements IAgentPlugin {
  readonly methods: IHeaderMethods;

  constructor() {
    this.methods = {
      getHeaderProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    let _user = storageSrv.get("userProfile", "session");
    // Detect platform
    let isAndroid = false;
    let isIOS = false;
    if (typeof navigator !== "undefined") {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      if (/android/i.test(userAgent)) {
        isAndroid = true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        isIOS = true;
      }
    }
    return { ...(config || {}), loginButton: {
      ...config.loginButton,
      link: isAndroid? "https://play.google.com/store/apps/details?id=io.vlinder.vtrag": "https://apps.apple.com/app/vtrag/id1621088916",
    } };
  }
}
